import React, { useState, createContext, useContext, useCallback } from 'react'
import { useAuth } from './auth'
/*import {getParamsFromResource, getPopupParams} from "../api/request";
import notify from "devextreme/ui/notify";
import StorageService from "../services/storage.service";*/

function ReqPopupProvider(props) {

  const [isOpen, setIsOpen] = useState(false)
  const [defaultType, setDefaultType] = useState()
  const [defaultMessage, setDefaultMessage] = useState()
  const [defaultFiles, setDefaultFiles] = useState([])
  const dogVisibleTypes = [2,5,6,7,1] //типы заявок с видимостью селекта договоров
  const pointVisibleTypes = [5,6] //типы заявок с видимостью селекта точек
  const [tuList, setTuList] = useState([])
  const [selectedTu, setSelectedTu] = useState(null)
  const [disabledTypes, setDisabledTypes] = useState(false)
  const [pu, setPu] = useState(null)
  //пока выношу сюда переменную для диалога подачи заявки в тех. поддержку, дабы не городить контекст
  const [visibleHelpPopup, setVisibleHelpPopup] = useState(false)
  //
  const [newdogFiles, setNewdogFiles] = useState([])
  const { reqTypes} = useAuth()
  const [typeFileLimit, setTypeFileLimit] = useState({})
  const [sendMessage, setSendMessage] = useState(false)


  /*  useEffect(()=> {
      let isMounted = true; // Флаг для отслеживания статуса компонента
      (async function(){
        if (auth[0]) {
        const res = await getParamsFromResource('FILE_LIMITS')
        if (!isMounted) return; // Проверяем, смонтирован ли компонент
        if (res.isOk) {
          if (isMounted) { // Обновляем состояние только если компонент смонтирован
            setfileLimits(JSON.parse(res.data.paramValue))
          }
        } else {
          notify(res.message,'error',5000)
        }
      }})()
      return () => {
        isMounted = false; // Устанавливаем флаг в false при размонтировании компонента
      };

    },[auth])*/

  const openReqPopup = useCallback((visible, type = null, message= null, files = [], tu = [], disableTypes = true, pu = null, FILE_LIMIT = 'req') => {
    setTypeFileLimit(FILE_LIMIT)
    setDefaultType(type)
    setIsOpen(visible)
    setDisabledTypes(disableTypes)
    if (type !== null && message === null) {
      const newType = reqTypes.find(item => item.id === type)
      setDefaultMessage(newType ? newType.defaultText : null)
    } else if (type !== null && message !== null) {
      setDefaultMessage(message)
    } else {
      setDefaultMessage(message)
    }
    setDefaultFiles(files)
    setTuList(tu)
    setPu(pu)
  }, [reqTypes])

  return (
      <ReqPopupContext.Provider value={{ isOpen, openReqPopup, defaultType, defaultMessage, setDefaultMessage, defaultFiles, setDefaultType,
        dogVisibleTypes, pointVisibleTypes, tuList, setTuList, selectedTu, setSelectedTu, disabledTypes, setDisabledTypes,
        visibleHelpPopup, setVisibleHelpPopup, newdogFiles, setNewdogFiles, pu, setPu, typeFileLimit, sendMessage, setSendMessage }} {...props} />
  )
}

const ReqPopupContext = createContext({})
const useReqPopup = () => useContext(ReqPopupContext)

export { ReqPopupProvider, useReqPopup }
